export default __webpack_public_path__ + "static/media/lamp.be921cf7.svg";